import React from 'react'
import Carousel from '../sections/Carousel'
import { TracingBeamDemo } from '../TraceBeamDemo'
import WhatWeDo from './WhatWeDo'
import ProjectCarousel from '../sections/ProjectCarousel'
import AreasOfWorkSection from '../sections/AreasOfWorkSection'
import AreasOfWorkB from '../sections/AreasOfWorkB'
import CampaignShowcase from '../sections/CampaignShowcase'
import CampaignSection from '../sections/CampaignSection'
import PartnersCarousel from '../sections/PartnerCarousel'
import Footer from '../sections/Footer'
import NewsSection from '../sections/NewsSection'
import ResourceList from '../sections/ResourceList'
import ResourcesSection from '../sections/ResourceSection'
import HeroSectionTwo from '../sections/HeroSectionTwo'
import ArticleStoriesSection from '../sections/ArticlesStoriesSection'

function Home() {
  return (
    <div className='home-page'>
      {/* <WhatWeDo /> */}
        {/* <Carousel /> */}
        {/* <TracingBeamDemo/> */}
        <HeroSectionTwo/>
        <div className='center-news-section'>
           <NewsSection/>
        </div>
        
        <AreasOfWorkSection/>
        <div className='center-news-section'>
           <ArticleStoriesSection/>
        </div>
        <CampaignSection/>
        {/* <CampaignShowcase /> */}
        {/*  */}
        
        <h2 className="section-title">Browse Our Programs & Projects</h2>
        <ProjectCarousel/>


      
        <PartnersCarousel />
        <h2 className="section-title">Learn More</h2>
        <div className='center-news-section'>
        <ResourcesSection />
        </div>
        

    </div>
  )
}

export default Home